import React, { useEffect, useState } from "react";
import { Dropdown } from "react-bootstrap";
import { faFolder, faFile, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface Template {
  id: number;
  name: string;
  content: string;
  created_at: string;
  updated_at: string;
  folder_id?: number;
  user_id?: number;
  location_id?: number;
  org_id?: number;
  deleted_at?: string | null;
  html?: string;
  css?: string;
  type?: string;
}

interface Folder {
  folder_id: number;
  folder_name: string;
  folder_type: string;
  folder_created_at: string;
  folder_updated_at: string;
  templates: Template[];
}

interface MultiLevelDropdownProps {
  data: Folder[];
  onSelect: (id: string, fullTemplate: Template) => void;
  value: string;
  disabled?: boolean;
}

const MultiLevelDropdown: React.FC<MultiLevelDropdownProps> = ({
  data,
  onSelect,
  value,
  disabled,
}) => {
  const [selectedTemplateName, setSelectedTemplateName] = useState<string | null>("");
  const [hasData, setHasData] = useState<boolean>(false);

  useEffect(() => {
    if (value && data.length > 0) {
      const foundTemplate = data
        .map((folder: any) =>
          folder.templates.find((template: any) => template.id === +value)
        )
        .find((template) => template !== undefined);
      foundTemplate && setSelectedTemplateName(foundTemplate.name);
    }
    setHasData(data.length > 0);
  }, [value, data]);

  const renderMenuItem = (item: Folder | Template) => {
    if ("templates" in item) {
      return (
        <Dropdown key={item.folder_id}>
          <Dropdown.Toggle
            variant="default"
            id={`dropdown-${item.folder_name}`}
          >
            <FontAwesomeIcon icon={faChevronRight} className="me-2"/>
            <div className="position-relative d-inline-block me-3">
              <FontAwesomeIcon icon={faFolder} className="me-1"/> {item.folder_name}
              <span className="template-count-badge multilevel-dropdown-badge">{item.templates.length}</span>
            </div>
          </Dropdown.Toggle>
          <Dropdown.Menu style={{ width: "100%" }}>
            {item.templates?.map((child: Template) => renderMenuItem(child))}
          </Dropdown.Menu>
        </Dropdown>
      );
    } else {
      return (
        <Dropdown.Item
          key={item.id}
          onClick={() => {
            onSelect(item.id.toString(), item);
            setSelectedTemplateName(item.name);
          }}
        >
          <FontAwesomeIcon icon={faFile} className="me-1"/> {item.name}
        </Dropdown.Item>
      );
    }
  };

  return (
    <div>
      <Dropdown className="templateCustomDropdown">
        {hasData ? (
          <>
            <Dropdown.Toggle
              id="dropdown-basic"
              className="templateDropdown form-select"
              disabled={disabled}
            >
              {selectedTemplateName ? selectedTemplateName : "Choose"}
              {/* {hasData ? (selectedTemplateName ? selectedTemplateName : "Choose") : "No options"} */}
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ width: "100%" }} className="inside-toggles">
              {data.map((item) => renderMenuItem(item))}
            </Dropdown.Menu>
          </>
        ) : (
          <Dropdown.Toggle
            id="dropdown-basic"
            className="templateDropdown form-select"
            disabled
          >
            No options
          </Dropdown.Toggle>
        )}
      </Dropdown>
    </div>
  );
};

export default MultiLevelDropdown;
